import * as a from 'actions/livefeed/livefeedOptions'
import update from 'immutability-helper';

export default (state, action) => {
    switch (action.type) {
        // ------------------------------------Livefeed option state update
        case a.SET_LOCATIONS: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { floorplanOptions: { locationsID: { $set: action.payload } } } }
            })
        }
        case a.SET_DURATION: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { floorplanOptions: { duration: { $set: action.payload } } } }
            })
        }
        case a.SET_LOCK_SCROLL: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { floorplanOptions: { lockScroll: { $set: action.payload } } } }
            })
        }
        case a.SET_WIDGET_LABEL_TYPE: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { floorplanOptions: { widgetLabelType: { $set: action.payload } } } }
            })
        }
        case a.SENSOR_FILTER_TYPE: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { floorplanOptions: { sensorFilterType: { $set: action.payload } } } }
            })
        }
        case a.SET_STANDBY_SENSOR_TREATMENT: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { floorplanOptions: { isStandbyAsUnOccupied: { $set: action.payload } } } }
            })
        }
        default: {
            return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/livefeededitor/livefeedOptionsReducer.js